<template>
  <tr>
    <td>{{ user.lastname }}</td>
    <td>{{ user.firstname }}</td>
    <td>{{ user.email }}</td>
    <td>{{ user.userRole }}</td>
    <td>{{ user.credits | formatNumber }} SMS</td>
    <td class="text-right" v-if="isAdmin">
      <!-- <input type="checkbox" :key="user.id" :value="user.id" class="user-checkbox" ref="checkedOrNot" @click="$emit('add-to-bulk-delete', user)" :checked="isChecked"> -->
      <button class="btn btn-danger" @click="$emit('show-delete-user-modal', user)"><i class="fas fa-trash-alt"></i></button>
      <button class="btn btn-primary" @click="$emit('validate', user)"><i class="fas" :class="user.isValidated ? 'fa-thumbs-up' : 'fa-thumbs-down'"></i></button>
      <button class="btn btn-secondary" @click="$emit('edit', user)"><i class="fas fa-pencil-alt"></i></button>
    </td>
  </tr>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      isChecked: false
    };
  },
  computed: {
    ...mapGetters({ isAdmin: 'auth/isAdmin' })
  },
  props: {
    user: {
      required: true,
      type: Object
    },
    usersToDelete: {
      required: false,
      type: Array
    }
  },
  beforeUpdate() {
    for (let i = 0; i < this.usersToDelete.length; i++) {
      if (this.usersToDelete[i].id === this.user.id) {
        this.isChecked = true;
        return;
      }
      this.isChecked = false;
    }
  }
};
</script>
